import { CMP_TYPOGRAPHY_UI_PRODUCT_CARD_HEADLINE, CMP_TYPOGRAPHY_UI_PRODUCT_CARD_PRICE_PRIMARY, CMP_TYPOGRAPHY_UI_PRODUCT_CARD_PRICE_SECONDARY, CMP_TYPOGRAPHY_UI_PRODUCT_CARD_SUBLINE, SYS_BLUR_BACKGROUND_300, SYS_BORDER_RADIUS_MD, SYS_BORDER_WIDTH_100, SYS_SPACE_FIXED_100, SYS_SPACE_FIXED_150, SYS_SPACE_FIXED_200, SYS_SPACE_FIXED_300, SYS_SPACE_FIXED_50, SYS_TYPOGRAPHY_COPY_ORDER3_NORMAL, getMargins, getTypographyStyles } from '@oneaudi/unified-web-alpha-common';
import styled, { css } from 'styled-components';
import { TextButton } from '../text-button/index.js';
import {} from './index.js';
import { IconButton } from '../icon-button/index.js';
export const StyledContainer = styled.div `
  ${(props) => css `
    margin: ${getMargins(props.margin)};
    background-color: ${props.theme.cmp.color.ui.productTile.surface.fill
    .default};
    box-shadow: inset 0px 0px 0px ${SYS_BORDER_WIDTH_100}
      ${props.theme.cmp.color.ui.productTile.surface.stroke.default};
    border-radius: ${SYS_BORDER_RADIUS_MD};
    backdrop-filter: blur(${SYS_BLUR_BACKGROUND_300});
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  `}
`;
export const StyledContent = styled.div `
  display: flex;
  align-self: normal;
  flex-direction: column;
  padding: ${SYS_SPACE_FIXED_300};
  gap: ${SYS_SPACE_FIXED_200};
`;
export const StyledHeadlineContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${SYS_SPACE_FIXED_50};
`;
export const StyledTagContainer = styled.div `
  display: flex;
  gap: ${SYS_SPACE_FIXED_50};
  flex-wrap: wrap;
`;
export const StyledTextButton = styled(TextButton) `
  width: 100%;
`;
export const StyledCTAContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${SYS_SPACE_FIXED_150};
  align-items: center;
`;
export const StyledDisclaimer = styled.div `
  ${getTypographyStyles(SYS_TYPOGRAPHY_COPY_ORDER3_NORMAL)}
  color: ${(props) => props.theme.sys.color.text.copy.default}
`;
// TODO is this the proper image styling? Clarify with needs of FA
export const StyledImageContainer = styled.div `
  width: 100%;
  display: flex;
  ${(props) => props.aspectRatio &&
    css `
      aspect-ratio: ${props.aspectRatio};
    `}
`;
// TODO is this the proper image styling? Clarify with needs of FA
export const StyledImage = styled.img `
  object-fit: ${(props) => props.objectFit ?? 'cover'};
  width: 100%;
`;
export const StyledTextContent = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${SYS_SPACE_FIXED_100};
`;
export const StyledPrice = styled.div `
  ${(props) => getTypographyStyles(props.variant === '1'
    ? CMP_TYPOGRAPHY_UI_PRODUCT_CARD_PRICE_PRIMARY
    : CMP_TYPOGRAPHY_UI_PRODUCT_CARD_PRICE_SECONDARY)}
  color: ${(props) => props.theme.sys.color.text.copy.default}
`;
export const StyledHeadline = styled.div `
  margin: 0;
  ${(props) => getTypographyStyles(props.variant === 'headline'
    ? CMP_TYPOGRAPHY_UI_PRODUCT_CARD_HEADLINE
    : CMP_TYPOGRAPHY_UI_PRODUCT_CARD_SUBLINE)}

  color: ${(props) => props.variant === 'headline'
    ? props.theme.sys.color.text.headline.default
    : props.theme.sys.color.text.copy.default}
`;
export const StyledIconButtonWrapper = styled.div `
  display: flex;
  justify-content: space-between;
  padding: ${SYS_SPACE_FIXED_300} ${SYS_SPACE_FIXED_300} 0
    ${SYS_SPACE_FIXED_300};
  align-items: center;
  gap: ${SYS_SPACE_FIXED_50};
`;
export const StyledIconButton = styled(IconButton) `
  align-self: end;
  margin: ${SYS_SPACE_FIXED_300} ${SYS_SPACE_FIXED_300} 0 0;
`;
export const StyledPricesContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${SYS_SPACE_FIXED_50};
`;
//# sourceMappingURL=index.styles.js.map